import { build_exception_drawer } from './exceptions_drawer_helpers';

const tabs = [
  { id: 'all', label: 'All', count: 6 },
  { id: 'procurement', label: 'Procurement', count: 3 },
  { id: 'finance', label: 'Finance', count: 1 },
  { id: 'policy', label: 'Policy', count: 2 }
];

const summary_cards = [
  { label: 'Open exceptions', value: '6', note: 'This quarter', tone: 'neutral' },
  { label: 'Approved', value: '3', note: 'With audit trail', tone: 'green' },
  { label: 'Total value', value: 'R649.0k', note: 'Across exceptions', tone: 'neutral' },
  { label: 'Unapproved / pending', value: '2', note: 'Need decision', tone: 'red' }
];

const exception_rows = [
  { ref: 'EX-01', exception: 'Emergency procurement - generator repair', type: 'Emergency procurement', value: 'R 145 000', approved_by: 'Accounting Officer', status: 'Approved', status_class: 'bg-success-subtle text-success-emphasis', category: 'procurement' },
  { ref: 'EX-02', exception: 'Sole-source - proprietary software renewal', type: 'Sole-source appointment', value: 'R 320 000', approved_by: 'CFO - M. Khan', status: 'Approved', status_class: 'bg-success-subtle text-success-emphasis', category: 'procurement' },
  { ref: 'EX-03', exception: 'Payment without complete 3-way match - INV-2199', type: 'Payment exception', value: 'R 120 000', approved_by: '-', status: 'Unapproved', status_class: 'bg-danger-subtle text-danger-emphasis', category: 'finance' },
  { ref: 'EX-04', exception: 'Deviation from three-quote rule - single quote', type: 'Procurement deviation', value: 'R 64 000', approved_by: 'SCM Manager', status: 'Approved', status_class: 'bg-success-subtle text-success-emphasis', category: 'procurement' },
  { ref: 'EX-05', exception: 'Late contract renewal signed after expiry', type: 'Contract exception', value: '-', approved_by: 'Legal - A. de Wet', status: 'Pending ratification', status_class: 'bg-warning-subtle text-warning-emphasis', category: 'policy' },
  { ref: 'EX-06', exception: 'Remote access without MFA - temporary', type: 'Policy exception', value: '-', approved_by: 'CISO - R. Govender', status: 'Expiring', status_class: 'bg-warning-subtle text-warning-emphasis', category: 'policy' }
];

function exception_record(type, title, subtitle, icon, tone = 'slate') {
  const activityItem = {
    type,
    title,
    subtitle,
    icon,
    tone
  };

  return activityItem;
}

function exception_check(title, status, tone) {
  const status_summary = {
    title,
    status,
    tone
  };

  return status_summary
}

function exception_action(label, style = 'secondary') {
  const statusBadge = {
    label,
    style
  };

  return statusBadge;
}

const exception_drawer_blueprints = {
  'EX-01': {
    kicker: 'Exception - EX-01',
    subtitle: 'Emergency - head office standby power',
    reason: 'Head office standby generator failure',
    approver: 'Accounting Officer',
    status_note: 'Approved - evidence on file',
    connected_records: [
      exception_record('Procurement', 'Emergency RFQ', '', 'bi-cart', 'teal'),
      exception_record('Asset', 'Standby generator', '', 'bi-building-gear', 'teal'),
      exception_record('Finance', 'Payment', '', 'bi-cash-coin', 'teal')
    ],
    recommendation: 'Properly approved with documented reason and evidence. Confirm it is included in the quarterly irregular/emergency expenditure note to the audit committee.',
    footer_actions: [
      exception_action('Evidence'),
      exception_action('View audit trail', 'primary')
    ]
  },
  'EX-02': {
    kicker: 'Exception - EX-02',
    subtitle: 'Sole-source - no alternative supplier',
    reason: 'Proprietary system - only OEM can renew',
    approver: 'CFO - M. Khan',
    status_note: 'Approved - motivation attached',
    connected_records: [
      exception_record('Procurement', 'Sole-source pack', '', 'bi-cart', 'teal'),
      exception_record('Licence', 'Software licences', '', 'bi-folder2-open', 'teal')
    ],
    recommendation: 'Motivation is on file. Diarise the renewal so it does not recur as an emergency next cycle.',
    footer_actions: [
      exception_action('Evidence'),
      exception_action('View motivation', 'primary')
    ]
  },
  'EX-03': {
    kicker: 'Exception - EX-03',
    subtitle: 'Blocked - requested override',
    reason: 'Supplier pressure on overdue invoice',
    approver: 'Pending - none granted',
    status_note: 'Unapproved - payment held',
    checks_alert: '2 need action',
    checks: [
      exception_check('Goods received note', 'Missing', 'red'),
      exception_check('PO match', 'Partial', 'orange')
    ],
    connected_records: [
      exception_record('Finance', 'INV-2199 hold', '', 'bi-cash-coin', 'teal'),
      exception_record('Supplier', 'BlueData Services', '', 'bi-truck', 'teal')
    ],
    recommendation: 'Do not grant this override without the GRN. Keep INV-2199 on hold and request delivery evidence; escalate the supplier pressure to the CFO.',
    footer_actions: [
      exception_action('Evidence'),
      exception_action('Escalate to CFO', 'primary')
    ]
  },
  'EX-04': {
    kicker: 'Exception - EX-04',
    subtitle: 'Deviation - specialised service',
    reason: 'Specialised forensic service - limited market',
    approver: 'SCM Manager',
    status_note: 'Approved',
    connected_records: [
      exception_record('Obligation', 'OB-04 three quotes', '', 'bi-list-check', 'teal'),
      exception_record('Procurement', 'Deviation pack', '', 'bi-cart', 'teal')
    ],
    recommendation: 'Approved within delegation. Ensure it is reflected against obligation OB-04 so the three-quote obligation shows the documented exception.',
    footer_actions: [
      exception_action('Evidence'),
      exception_action('View deviation', 'primary')
    ]
  },
  'EX-05': {
    kicker: 'Exception - EX-05',
    subtitle: 'Policy exception - retrospective',
    reason: 'Approval delay over month-end',
    approver: 'Legal - awaiting EXCO ratification',
    status_note: 'Pending ratification',
    connected_records: [
      exception_record('Contract', 'Affected contract', '', 'bi-file-earmark-text', 'teal'),
      exception_record('Authority', 'DoA breach', '', 'bi-sign-turn-slight-right', 'teal')
    ],
    recommendation: 'Retrospective approvals must be ratified. Route to EXCO and record the lesson to prevent a recurring late-renewal pattern.',
    footer_actions: [
      exception_action('Evidence'),
      exception_action('Route for ratification', 'primary')
    ]
  },
  'EX-06': {
    kicker: 'Exception - EX-06',
    subtitle: 'Time-boxed security exception',
    reason: 'Vendor migration in progress',
    approver: 'CISO - R. Govender',
    expiry: '30 Jun 2026',
    status_note: 'Expiring - review required',
    connected_records: [
      exception_record('IT security', 'Access controls', '', 'bi-lock', 'teal'),
      exception_record('Risk', 'Privileged access', '', 'bi-exclamation-triangle', 'teal')
    ],
    recommendation: 'This waiver expires soon. Confirm the migration is complete and let the exception lapse - do not extend without a fresh CISO approval.',
    footer_actions: [
      exception_action('Evidence'),
      exception_action('Review exception', 'primary')
    ]
  }
};

const drawer_tone_class_map = {
  teal: 'is-green',
  green: 'is-green',
  orange: 'is-orange',
  amber: 'is-orange',
  red: 'is-red',
  slate: 'is-slate'
};

export default {
  name: 'ComplyonExceptionsDeviations',
  data: () => ({
    tabs,
    summary_cards,
    exception_rows,
    active_tab: 'all',
    search_query: '',
    active_exception_drawer_ref: null
  }),
  computed: {
    filtered_rows() {
      const query = this.search_query.trim().toLowerCase();

      return this.exception_rows.filter((row) => {
        const matches_tab = this.active_tab === 'all' || row.category === this.active_tab;
        const searchable_values = [row.ref, row.exception, row.type, row.value, row.approved_by, row.status];
        const matches_query = !query || searchable_values.some((value) => String(value).toLowerCase().includes(query));

        return matches_tab && matches_query;
      });
    },

    active_exception_drawer() {
      if (!this.active_exception_drawer_ref) {
        return null;
      }

      const row = this.exception_rows.find((item) => item.ref === this.active_exception_drawer_ref);
      return row ? build_exception_drawer(row, exception_drawer_blueprints, exception_action) : null;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    },

    set_overlay_state() {
      if (typeof document === 'undefined') {
        return;
      }

      document.body.classList.toggle('exceptions-overlay-open', Boolean(this.active_exception_drawer_ref));
    },

    open_exception_drawer(row) {
      if (!row?.ref) {
        return;
      }

      this.active_exception_drawer_ref = row.ref;
      this.set_overlay_state();
    },

    close_exception_drawer() {
      this.active_exception_drawer_ref = null;
      this.set_overlay_state();
    },

    drawer_tone_class(tone) {
      const tone_class = Reflect.get(drawer_tone_class_map, tone) || 'is-slate';
      return tone_class;
    },

    footer_button_class(style) {
      return style === 'primary'
        ? 'btn config-navbar-primary-action d-inline-flex align-items-center gap-2'
        : 'btn btn-outline-secondary d-inline-flex align-items-center gap-2';
    }
  },

  mounted() {
    this.set_overlay_state();
  },

  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('exceptions-overlay-open');
    }
  },

  watch: {
    active_exception_drawer_ref() {
      this.set_overlay_state();
    }
  }
};
